module.exports = __webpack_public_path__ + "img/landingPage.935f4fd0.png";